import stat from '../../utils/stat';
import VideoManager from './Manager';

const PluginStat = window.Aliplayer
  ? window.Aliplayer.Component({
      init: function(videoid: number, playerId: string | number) {
        this.videoid = videoid;
        this.playerId = playerId;
      },
      play: function(player: any) {
        stat.event('video_play', this.videoid);
        stat.time(this.videoid, 'video_time', {
          id: this.videoid
        });

        // 互斥播放
        VideoManager.mutex(this.playerId);
      },
      pause: function(player: any) {
        stat.timeEnd(this.videoid);
      }
    })
  : null;

export default PluginStat;
